import { GenericElement } from '../../templates/FormElement';

// Global constants
import * as con from "../../GlobalConstants"
import { Button } from '@blueprintjs/core';

import "../ComponentsGlobalStyle.css"
import { StateModelParameterHook } from '../hooks/ModelParameterHooks';

function BandParameters() {
    
    // Model Parameters
    // -----------------
    const [bandWidth, setBandWidth] = StateModelParameterHook(con.BAND_WIDTH)
    const [initialCoverge, setInitialCoverge] = StateModelParameterHook(con.INITIAL_COVERAGE)
    const [gradient, setGradient] = StateModelParameterHook(con.GRADIENT)

    
    // Scheme Variable
    const [isAutomatic, setIsAutomatic] = StateModelParameterHook(con.AUTOMATIC_BANDS)


    
    return (
    <div>

        <div>
            <div className="columnParameterBox" >  
                        < GenericElement type={con.PERCENTAGE}
                                        name={"Ancho de Banda"}
                                        id={"band_width"} 
                                        value={bandWidth} 
                                        setValue={(val) => setBandWidth(val)} 
                                        />      
        </div>
        
        <div className="smallParameterBox" >        
        
            <Button text="Automático" onClick={()=> setIsAutomatic(true)} outlined={!isAutomatic} className="selectedButton"/>
            <Button text="Manual"  onClick={()=> setIsAutomatic(false)} outlined={isAutomatic} className="selectedButton"/>

            
        </div>                                  
                    <div className="mediumParameterBox" >                                        
                        < GenericElement type={con.PERCENTAGE}
                                        name={"Cobertura Inicial"}
                                        id={"initial_coverage"} 
                                        value={initialCoverge} 
                                        setValue={(val) => setInitialCoverge(val)}
                                        disabled={!isAutomatic}  
                                        />                     

                        < GenericElement type={con.PERCENTAGE}
                                        name={"Gradiente"}
                                        id={"gradient"} 
                                        value={gradient} 
                                        setValue={(val) => setGradient(val)}
                                        disabled={!isAutomatic} 
                                        />
                    </div>
                                        

        </div>

    </div>
    )
}

export default BandParameters
